import ModalWindow from "../../../../../../Components/ModalWindow/ModalWindow";
import UsersRequests from "../../../../../../Services/Api/UserRequests.ts";
import { AddToastNotification } from "../../../../../../Services/ToastNotification/ToastNotificationManager";

const ResetPasswordModal = ({resetPasswordUser, setResetPasswordUser}) => {
    const userRequests = new UsersRequests();
    
    const reset = () => {
        userRequests.ResetPassword(resetPasswordUser.id, () => 
        {
            AddToastNotification("Hasło użytkownika zresetowane!", 1)
            setResetPasswordUser(null);
        });
    }

    return (
        <ModalWindow 
            title={"Restart hasła"}
            buttons={[
                { Text: "Tak", onClick: () => reset() },
                { Text: "Nie", className: "modalSecondaryBtn", onClick: () => setResetPasswordUser(null) }
            ]}
            content={
                <div>
                    Czy na pewno chcesz zrestartować hasło dla użytkownika <span className="text-glred">{resetPasswordUser.login}</span>?
                </div>
            }
        />
    )
};

export default ResetPasswordModal;